<template>
    <div class ="overlay">
        <div class="my-reports">
            <div class="my-reports-header">
                <h1>My Reports</h1>
                <button @click="$emit('close_my_reports')" class="close-button">Close</button>
            </div>
            <div class="loading-spinner" v-if="loading">
                <img src="@/assets/svg/12-dots-scale-rotate-magecdn.svg" alt="Loading..." class="loading-image">
            </div>
            <div class="my-reports-body" v-if="!loading">
                <div v-if="error" class="error-message">{{ error }}</div>
                <div v-else-if="reports.length === 0" class="no-reports">No reports found</div>
                <div v-else>
                    <div v-for="report in reports" :key="report" class="my-report-row">
                        <div class="report-row-name">
                            <p class="report-name">{{ report }}</p>
                        </div>
                        <div class="report-row-button">
                            <button @click="downloadReport(report)"
                                :disabled="report_states[report] == 'downloading'"
                                class="download-button"
                                :class="{ 'downloading': report_states[report] == 'downloading' }">
                                <span v-if="report_states[report] == 'downloading'"><img src="@/assets/svg/12-dots-scale-rotate-magecdn.svg" alt="Loading..." class="button-image"></span>
                                <span v-else-if="report_states[report] == 'ready'"><img src="@/assets/svg/download_icon_iconoir.svg" alt="Download" class="button-image"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { fetchUserReports, downloadReport} from '@/api_requests.ts';
export default {
    name: "MyReports",
    props: {
        userProfile: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            reports: [],
            report_states: {},  /* Keep an object with the filenames as keys, this allows us to track download state of each report independently */
            loading: false,
            error: null,
            downloadingReport: null,
        }
    },

    async mounted() {
        if (!this.userProfile) {
            this.error = "User profile not found";
            return;
        }
        await this.loadReports();
    },

    methods: {
        async loadReports() {
            try {
                this.loading = true;
                this.error = null;

                const keycloakId = this.userProfile.sub || this.userProfile.id;
                console.log("Fetching reports for user ID:", keycloakId);
                this.reports = await fetchUserReports(keycloakId);

                for(const report of this.reports){
                    this.report_states[report] = "ready";
                }

                console.log("Fetched reports:", this.reports);
            } catch (err) {
                this.error = "Failed to load reports";
                console.error("Error fetching reports:", err);
            } finally {
                this.loading = false;
            }
        },

        async downloadReport(reportName){
            try {
                this.report_states[reportName] = "downloading";
                await downloadReport(reportName);
                this.report_states[reportName] = "ready";
            } catch (err) {
                console.error("Error downloading report:", err);
            } finally {
                this.report_states[reportName] = "ready";
            }
        }
    }
}
</script>
<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--colour-divider-dark-2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.my-reports {
    background-color: white;
    border-radius: var(--radius-md);
    box-shadow: 0 4px 20px var(--colour-divider-light-2);
    padding: var(--spacing-lg);
    width: 60%;
    max-height: 90%;
    overflow: auto;
}

.my-reports-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--spacing-lg);
    align-items: flex-start;
}

.my-reports-body {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.loading-image {
    width: 3rem;
    height: 3rem;
}

.my-report-row{
    display: flex;
    align-items: center;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    background-color: lightgray;
}

.my-report-row:first-child {
    border-top: 1px solid black; /* Only first row gets a top to handle overlapping */
    border-top-right-radius: var(--radius-md);
    border-top-left-radius: var(--radius-md);
}

.my-report-row:last-child {
    border-bottom-left-radius: var(--radius-md);
    border-bottom-right-radius: var(--radius-md);
}

.report-name {
    font-size: 1rem;
    font-weight: 500;
    margin-right: 1rem;
    margin-left: 0.5rem;
    display: flex;
}

.report-row-name {
    display: flex;
    flex: 80%;
}

.report-row-button
{
    display: flex;
    flex: 20%;
    justify-content: flex-end;
    margin-right: 0.5rem;
}

/* NOTE: Download button and its image require defined dimensions otherwise they may fail to render. */
.download-button {
    opacity: 1;
    background: transparent;
    border: none;
    display: flex;
    align-items:center;
    justify-content: center;
    min-width: 2rem;
    min-height: 2rem;
}

.button-image {
    width: 1.5rem;
    height: 1.5rem;
    object-fit: contain;
}

.close-button {
    background-color: var(--color-primary);
    color: white;
    border: none;
    border-radius: var(--radius-md);
    padding: var(--spacing-md) var(--spacing-lg);
    cursor: pointer;
    font-size: 1rem;
}

.close-button:hover {
    background-color: var(--color-primary-hover);
}

.download-button:disabled .button-image {
    opacity: 1;
}
</style>
